import React, { createContext, useContext, useState } from 'react';

type ExecOpContextType = {
  execOpInProgress: boolean;
  setExecOpInProgress: (_value: boolean) => void;
};

const ExecOpContext = createContext<ExecOpContextType | undefined>(
  undefined,
);

export const ExecOpProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [execOpInProgress, setExecOpInProgress] =
    useState<boolean>(false);

  const update = (value: boolean) => {
    setExecOpInProgress(value);
    localStorage.removeItem('execOpInProgress');
  };

  return (
    <ExecOpContext.Provider
      value={{ execOpInProgress, setExecOpInProgress: update }}
    >
      {children}
    </ExecOpContext.Provider>
  );
};

export const useExecOp = () => {
  const context = useContext(ExecOpContext);
  if (!context)
    throw new Error('useExecOp must be used within a ExecOpProvider');
  return context;
};
